<div class="new-request-container" *ngIf="requestSelectionState$ | async as requestSelectionState">
  @switch (requestSelectionState) {
    @case (RequestSelectionStates.SELECT_INCUMBENT) {
      <div class="title-bar" data-test="NewRequestTitleBar">
        <h2>Select Incumbent Criteria</h2>
      </div>

      <mat-dialog-content class="new-request-content">
        <app-request-target-search (incumbentSelected)="onIncumbentSelectionChange($event)"/>
      </mat-dialog-content>
    }
    
    @case (RequestSelectionStates.SELECT_CLIENTS) {
      <ng-container *ngIf="selectedIncumbentCriteria$ | async as selectedIncumbentCriteria">
        <div class="title-bar" data-test="NewRequestTitleBar">
          <h2>Filter {{ getIncumbentDisplayName(selectedIncumbentCriteria) }} by Client Spend</h2>
        </div>

        <mat-dialog-content class="new-request-content">
          <app-request-client-filter class="client-filter" 
              (selectedClients)="(onClientsSelectionChange($event))"
          />
        </mat-dialog-content>
      </ng-container>
    }
  }

  <mat-dialog-actions class="navigation-buttons" data-test="NewRequestNavButtons">
    <button mat-button (click)="closeModal()">Cancel</button>
    <button mat-raised-button color="primary" *ngIf="showBackButton(requestSelectionState)" (click)="backButtonClicked(requestSelectionState)">Back</button>
    <button mat-raised-button color="primary" [disabled]="nextIsDisabled$ | async" (click)="nextButtonClicked(requestSelectionState)">Next</button>
  </mat-dialog-actions>
</div>
